import { useSetAtom } from 'jotai';
import { atomWithReset, RESET } from 'jotai/utils';
import { useEffect } from 'react';

export const titleAtom = atomWithReset('Modul 1');

export function useTitle(title: string) {
    const setTitle = useSetAtom(titleAtom);
    useEffect(() => {
        setTitle(title);
        return () => {
            setTitle(RESET);
        };
    }, [title]);
}
